import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Input from '@bitcoin-portal/bitcoincom-pkg-components/dist/Input';
import Button from '@bitcoin-portal/bitcoincom-pkg-components/dist/Button';
import H1 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H1';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import Label from '@bitcoin-portal/bitcoincom-pkg-components/dist/Label';
import H2 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H2';
import Link from '@bitcoin-portal/bitcoincom-pkg-components/dist/Link';
import { colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import { useTheme } from 'styled-components';
import { Helmet } from 'react-helmet';
import SEO from '../../components/SEO';
import decipherWallet from './decipherWallet';
import Wallets from './Wallets';
import { Form } from './styled';
import Warning from './Warning';
import Navbar from '../../components/Navbar/NavbarHome';
import Footer from '../../components/FooterComponent/Footer';

const defaultErrors = {
  file: '',
  password: '',
  decrypt: '',
};

const Home = () => {
  // eslint-disable-next-line no-unused-vars
  const { locale } = useIntl();
  const [fileContent, setFileContent] = useState('');
  const theme = useTheme();
  const [password, setPassword] = useState('');
  const [wallets, setWallets] = useState();
  const [errors, setErrors] = useState(defaultErrors);

  const handleSubmit = async () => {
    setErrors({
      ...errors,
      file: !fileContent ? 'No file or error reading file' : '',
      password: !password ? 'No password' : '',
    });
    if (!fileContent || !password) {
      return;
    }

    const decipheredWallets = await decipherWallet(fileContent, password);
    if (!decipheredWallets) {
      setErrors({ ...errors, decrypt: 'Something went wrong, try again' });
    }

    setWallets(decipheredWallets);
  };

  const handleFileUpload = async e => {
    setErrors(defaultErrors);
    const reader = new FileReader();
    reader.onload = async ev => {
      setFileContent(ev.target.result);
    };
    reader.readAsText(e.target.files[0]);
  };

  return (
    <>
      <SEO page="decrypt" />
      <Helmet>
        <script
          src={
            process.env.MPC_WIDGET_URL ||
            'https://widget.bitcoin.com/widget.v0.7.14.iife.js'
          }
          type="text/javascript"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf"
          as="font"
          type="font/ttf"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@500..900&family=Noto+Sans:ital,wdth,wght@0,75..100,500..900;1,62.5..100,500..900&display=swap"
          rel="stylesheet"
          key="google-fonts2"
        />

        <style>
          {`
            @font-face {
              font-family: 'Elza Condensed';
              src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Satoshi Variable Medium';
              src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Chivo Mono';
              src: url('https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf') format('truetype');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
          `}
        </style>
      </Helmet>
      <Navbar />
      <Section>
        <ContentBlock
          flip={ContentBlock.Flips.Both}
          aside={
            <div>
              <H1
                style={{
                  fontFamily: "'Elza Condensed', sans-serif",
                  color: 'var(--Shades-900, #1c1c1c)',
                  fontWeight: 500,
                }}
              >
                <FormattedMessage id="decrypt.header.title" />
              </H1>
              <Paragraph
                style={{
                  fontFamily: "'Satoshi Variable Medium', sans-serif",
                  color: 'var(--Shades-700, #67656e) !important',
                }}
              >
                <FormattedMessage id="decrypt.header.description" />
              </Paragraph>
              <div
                style={{
                  background: colors.solid.mystic,
                  padding: 16,
                  borderRadius: 8,
                  marginRight: 16,
                }}
              >
                <H2
                  style={{
                    color: colors.solid.cinnabar,
                    fontFamily: "'Elza Condensed', sans-serif",
                    fontWeight: 500,
                  }}
                >
                  <FormattedMessage id="decrypt.header.warning.title" />
                </H2>
                <Paragraph
                  bold
                  style={{
                    fontFamily: "'Satoshi Variable Medium', sans-serif",
                    color: 'var(--Shades-700, #67656e) !important',
                  }}
                >
                  <FormattedMessage id="decrypt.header.warning.description" />
                </Paragraph>
                <Paragraph
                  bold
                  style={{
                    fontFamily: "'Satoshi Variable Medium', sans-serif",
                    color: 'var(--Shades-700, #67656e) !important',
                  }}
                >
                  <FormattedMessage
                    id="decrypt.header.warning.disclaimer"
                    values={{
                      download: (
                        <Link
                          href="https://github.com/Bitcoin-com/wallet-decrypt-tools/releases"
                          download
                        >
                          <FormattedMessage id="decrypt.header.warning.download" />
                        </Link>
                      ),
                    }}
                  />
                </Paragraph>
              </div>
            </div>
          }
        >
          {wallets ? (
            <div style={{ padding: 16 }}>
              <button
                type="button"
                style={{
                  background: 'transparent',
                  border: 'none',
                  outline: 'none',
                  ...theme.palette.primary.text,
                  fontSize: 20,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setWallets(undefined);
                }}
              >
                &lt; Decrypt another backup
              </button>
              <Wallets wallets={wallets} />
            </div>
          ) : (
            <Form
              onSubmit={e => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Input
                type={Input.Types.File}
                accept=".data"
                error={errors.file}
                label="Backup file (wallet.data)"
                onChange={handleFileUpload}
              />
              <Input
                type={Input.Types.Password}
                label="Password"
                error={errors.password}
                onChange={e => {
                  setErrors(defaultErrors);
                  setPassword(e.target.value);
                }}
              />
              <Button design="secondary" type="submit" onClick={handleSubmit}>
                Decrypt
              </Button>
              <Label error={errors.decrypt} />
            </Form>
          )}
        </ContentBlock>
      </Section>
      <Warning />
      <Footer />
    </>
  );
};

export default Home;
